export const  GET_TUTOR_SCHEDULE_REQUEST='tutorScheduleReducer/GET_TUTOR_SCHEDULE_REQUEST';
export const  GET_TUTOR_SCHEDULE_SUCCESS='tutorScheduleReducer/GET_TUTOR_SCHEDULE_SUCCESS';
export const  GET_TUTOR_SCHEDULE_FAILED='tutorScheduleReducer/GET_TUTOR_SCHEDULE_FAILED';